export const locationsUri = `:apiUri/real-estate-groups/:realEstateGroupId/locations`;
